import { render, staticRenderFns } from "./FollowIcon.vue?vue&type=template&id=e9d54944&"
import script from "./FollowIcon.vue?vue&type=script&lang=ts&"
export * from "./FollowIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports